<template>
  <div slot="no-body">
    <div class="p-8 login-tabs-container" v-if="token == null">
      <div class="vx-card__title mb-4">
        <h4 class="mb-4">Inloggen Hebtrek</h4>
      </div>
      <div>
        <form @submit="login">
          <vs-input
            v-validate="'required|email|min:3'"
            data-vv-validate-on="blur"
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Email"
            v-model="email"
            class="w-full"
          />
          <span class="text-danger text-sm">{{ errors.first('email') }}</span>

          <vs-input
            data-vv-validate-on="blur"
            v-validate="'required'"
            type="password"
            name="password"
            icon-no-border
            icon="icon icon-lock"
            icon-pack="feather"
            label-placeholder="Password"
            v-model="password"
            class="w-full mt-6"
            v-on:keyup.enter="login"
          />
          <span class="text-danger text-sm">{{ errors.first('password') }}</span>

          <div class="flex flex-wrap justify-between my-5">
            <router-link to="/pages/forgot-password">Wachtwoord vergeten?</router-link>
          </div>
          <vs-button class="float-right" :disabled="!validateForm" @click="login">Inloggen</vs-button>
        </form>
      </div>
    </div>
    <transition v-else>
      <ht-staff-2fa :token="token"></ht-staff-2fa>
    </transition>
  </div>
</template>

<script>
import HtStaff2fa from "./Staff2fa";

export default {
  name: "ht-staff-login",
  components: {
    HtStaff2fa,
  },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      token: null,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== "" && this.password !== "";
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (localStorage.getItem("stafftoken") !== null) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        this.router.push("/");

        return false;
      }
      return true;
    },
    login() {
      if (!this.checkLogin()) return;
      localStorage.removeItem("companytoken");
      localStorage.removeItem("user");
      // Loading
      this.$vs.loading();

      const data = {
        email: this.email,
        password: this.password,
      };

      this.$http
        .post("https://staffapi.hebtrek.nl/v1/authenticate", data)
        .then((response) => {
          if (response.data.token) {
            this.stopLoading();
            this.token = response.data.token;
          }
        })
        .catch((error) => {
          this.stopLoading();
          this.notify(
            "",
            "Verkeerde gebruikersnaam/wachtwoord, probeer het alsjeblieft opnieuw!"
          );
        });
    },
    stopLoading() {
      this.$vs.loading.close();
    },
    notify(title, message) {
      this.$vs.notify({
        title: title,
        text: message,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    },
  },
};
</script>
